export const layoutClassName = {
  label: 'tw-flex tw-items-center tw-h-5 tw-space-x-1',
  error: 'tw-min-h-[20px]',
}
